import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoSrc from 'assets/hvdm-logo-white.png';

const useScrolled = (threshold = 16) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
};

const Header = () => {
  const scrolled = useScrolled();
  // Normalise a trailing slash so the prerendered ("/contact") and client-served
  // ("/contact/") paths agree — otherwise the two branches below diverge and the
  // hydrated markup mismatches the prerendered HTML.
  const path = useLocation().pathname.replace(/\/+$/, '') || '/';
  const onContact = path === '/contact';

  return (
    <header
      className={[
        'fixed inset-x-0 top-0 z-[60] border-b pt-[max(env(safe-area-inset-top,0px),12px)] transition-[background-color,backdrop-filter,border-color] duration-[450ms] ease-out sm:pt-[env(safe-area-inset-top,0px)]',
        scrolled
          ? 'border-line-faint bg-[color-mix(in_oklch,var(--color-bg)_70%,transparent)] backdrop-blur-[10px]'
          : 'border-transparent bg-transparent'
      ].join(' ')}>
      <div className="flex h-[52px] w-full items-center justify-between px-5 sm:h-[78px] sm:px-6 md:px-12">
        <Link
          to="/"
          className="flex items-center gap-2.5 text-[15px] font-semibold tracking-[-0.01em] whitespace-nowrap sm:gap-3 sm:text-[17px]">
          <img src={logoSrc} alt="HVDM" className="inline-block h-[17px] w-auto sm:h-[19px]" />
          Harvey de Meester
        </Link>

        <nav className="flex items-center gap-[14px] sm:gap-5 md:gap-9">
          {onContact ? (
            /* Keyed so React mounts a fresh element instead of reusing the other
               Link's DOM node — reuse lets the .btn background transition out as
               a white flash behind this label. */
            <Link
              key="nav-home"
              to="/"
              className="text-fg-dim hover:text-fg text-sm transition-colors duration-[250ms]">
              ← Home
            </Link>
          ) : (
            <Link
              key="nav-contact"
              to="/contact"
              className="btn hidden px-[17px] py-[9px] text-[13px] md:inline-flex">
              Get in touch <span className="arr">↗</span>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
